import { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { useSelector, useDispatch } from 'react-redux';
import Box from '@material-ui/core/Box';
import {
	DELETE_DATASET_BTN_TEXT,
	Bogle_Regular,
	CANCEL,
	DELETE_DATASET_MODAL_TITLE,
	DELETE_DATASET_MSG_2,
	DELETE_DATASET_MSG_1,
	DELETE_DATASET_REPORT_MSG
} from 'constants/constant';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { deleteCustomDataset } from 'components/Template/Template.actions';
import { trackEventInfo } from 'helper/analytics';
import { PAGE_ID, EVENTS, ACTION_ON } from 'constants/tracker';

const { WHITE, ERROR_RED } = colors;

const useStyles = makeStyles(() => ({
	cancelButton: {
		height: 40,
		fontWeight: '700',
		textTransform: 'none !important',
		borderRadius: '50px  !important',
		marginRight: '8px'
	},
	deleteButton: {
		background: `${ERROR_RED}`,
		borderRadius: '50px  !important',
		height: 40,
		color: `${WHITE} !important`,
		fontSize: '14px',
		fontFamily: `${Bogle_Regular} !important`,
		textTransform: 'none !important',
		'&:hover': {
			background: `${ERROR_RED} !important`
		}
	},
	dialogContent: {
		borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
	},
	dialogTitle: {
		'& b': {
			fontSize: '24px !important'
		}
	}
}));

export const DeleteDatasetModal = ({ selectedDataset = {}, open, closeModalFn }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const reportsList = useSelector((state) => state.dashboardReducer.reportsList);
	const [associatedReportList, setAccociatedReportList] = useState([]);

	useEffect(() => {
		if (selectedDataset?.customDatasetId) {
			const filteredList = reportsList.filter(
				(item) => item.customDatasetId === selectedDataset?.customDatasetId
			);
			setAccociatedReportList(filteredList);
		}
	}, [selectedDataset]);

	const deleteReport = (dataset) => {
		dispatch(deleteCustomDataset(dataset));
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: ACTION_ON.CUSTOM_DATASET_DELETE,
			location: PAGE_ID.TEMPLATES
		});
	};

	const generateDeleteDatasetMsg = (name) => {
		return (
			<div>
				{DELETE_DATASET_MSG_1} <b>{name}</b>
				{DELETE_DATASET_MSG_2}
			</div>
		);
	};

	const getReportsFromSelectedDataset = (list) => {
		return (
			<div>
				<div>{DELETE_DATASET_REPORT_MSG}</div>
				<div>
					{list.map((report) => {
						return (
							<div key={report.reportId}>
								<b>{report.reportName}</b>
							</div>
						);
					})}
				</div>
			</div>
		);
	};

	return (
		<Dialog
			maxWidth="xs"
			style={{ zIndex: 99 }}
			aria-labelledby="delete-dataset-title"
			open={open}
			classes={{
				paper: classes.paper
			}}
			id="save-dataset-dialog"
			keepMounted
			PaperProps={{ id: 'delete-dataset-dialog-box', style: { borderRadius: 16 } }}
			onClose={() => {
				closeModalFn(false);
			}}>
			<DialogTitle id="delete-dataset-title" className={classes.dialogTitle}>
				<b>{DELETE_DATASET_MODAL_TITLE}</b>
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				<div>{generateDeleteDatasetMsg(selectedDataset?.cardTitle)}</div>
				{associatedReportList.length > 0 && (
					<>
						<br />
						<div>{getReportsFromSelectedDataset(associatedReportList)}</div>
					</>
				)}
			</DialogContent>
			<DialogActions>
				<Box>
					<Button
						className={classes.cancelButton}
						id="cancel-btn"
						onClick={() => {
							closeModalFn(false);
						}}
						variant="outlined">
						{CANCEL}
					</Button>
					<Button
						id="delete-btn"
						className={classes.deleteButton}
						disabled={''}
						onClick={() => {
							deleteReport(selectedDataset);
							closeModalFn(false);
						}}
						variant="outlined"
						startIcon={<DeleteOutlineIcon />}>
						{DELETE_DATASET_BTN_TEXT}
					</Button>
				</Box>
			</DialogActions>
		</Dialog>
	);
};
